import blackTipPage from './blackTip.vue';

const blackTip = {
    install: function(Vue) {
        Vue.component('blackTip', blackTipPage)
    }
}

export default blackTip;